import { TooltipPadding, TooltipPlacement } from 'constants/tooltip';

export const baseLockedIndicatorTooltipProps = {
  arrow: true,
  padding: TooltipPadding.LARGE,
  placement: TooltipPlacement.TOP,
};
